package com.vamvisions.main.core.domain.preferences

/**
 * An interface language. [code] is the ISO 639-1 code used in URLs, storage and `<html lang>`.
 * [nativeName] is the language's name in itself, the same in every interface language.
 */
enum class Language(val code: String, val nativeName: String) {
    EN("en", "English"),
    FR("fr", "Français"),
    RO("ro", "Română");

    companion object {
        fun fromCode(code: String): Language? = entries.firstOrNull { it.code == code }
    }
}
